export class ValidateWaitingListKeyError extends Error {}
export class RatesError extends Error {}
export class PromoCodeError extends Error {
    constructor(message) {
        super(message)

        this.message = message
    }
}

export class CreateReservationError extends Error {
    constructor(message) {
        super(message)

        this.message = message
    }
}
